import { render, staticRenderFns } from "./SortBar.vue?vue&type=template&id=c2f9678e&scoped=true"
import script from "./SortBar.vue?vue&type=script&lang=js"
export * from "./SortBar.vue?vue&type=script&lang=js"
import style0 from "./SortBar.vue?vue&type=style&index=0&id=c2f9678e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f9678e",
  null
  
)

export default component.exports